/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Property_Ai_Publish_All_DoneInputs */

const cs_property_ai_publish_all_done = /** @type {(inputs: Property_Ai_Publish_All_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publikováno fotek: ${i?.count}`)
};

const en_property_ai_publish_all_done = /** @type {(inputs: Property_Ai_Publish_All_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Published ${i?.count} photos`)
};

/**
* | output |
* | --- |
* | "Published {count} photos" |
*
* @param {Property_Ai_Publish_All_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_publish_all_done = /** @type {((inputs: Property_Ai_Publish_All_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Publish_All_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_publish_all_done(inputs)
	return cs_property_ai_publish_all_done(inputs)
});